import { render, staticRenderFns } from "./applicant-guardian-consent.vue?vue&type=template&id=05a6c252&lang=pug&"
import script from "./applicant-guardian-consent.vue?vue&type=script&lang=js&"
export * from "./applicant-guardian-consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a6c252')) {
      api.createRecord('05a6c252', component.options)
    } else {
      api.reload('05a6c252', component.options)
    }
    module.hot.accept("./applicant-guardian-consent.vue?vue&type=template&id=05a6c252&lang=pug&", function () {
      api.rerender('05a6c252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/applicantGuardianConsent/applicant-guardian-consent.vue"
export default component.exports